import * as React from "react";
import { Spinner, Text } from "@fluentui/react-components";

type ILoaderProps = {
    msg: string;
};

export const CustomLoader = (props: ILoaderProps) => {
    return (
        <div className="fixed inset-0 flex flex-col justify-center items-center gap-3 text-(--colorNeutralForeground1) bg-(--theme-bg-1) overflow-hidden">
            <Spinner size="large" />
            <Text>{props.msg}</Text>
        </div>
    );
};

export default CustomLoader;
